export class BookFilterType{
    constructor(){}

    static readonly ProviderBook = 1;
    static readonly OfficeBook = 2;
}